import './styles.css';
import { useState, useEffect } from 'react';
import PracticeSession from "../../common/PracticeSession";
import LearnSession from '../../common/LearnSession';
import { useIsSmallScreen, useIsTinyMobileScreen, useIsMediumScreen }from '../../hooks/screenSizeHooks';
import { useLocation } from 'react-router-dom';
import  practiceMetaData from './practiceMetaData';
import PageNotFound from '../../common/PageNotFound';
import { Typography } from '@mui/material';
import SEO from '../../common/SEO';

const PracticePage = () => {
  const isSmallScreen = useIsSmallScreen();
  const isMediumScreen = useIsMediumScreen(); 
  const isTinyMobileScreen = useIsTinyMobileScreen();
  const location = useLocation();
  const [dataIndex,setDataIndex ] = useState(0);

	useEffect(() => {
		if(!!practiceMetaData[location.pathname]) {
				setDataIndex(0);
		} 
 	 }, [ location.pathname])

  return(
    <>
      <SEO pageName="practice" />
      {!practiceMetaData[location.pathname] ?
        <PageNotFound />
        :
        <>
          <Typography variant='h5' className='practicePageText'>{practiceMetaData[location.pathname].practiceTitle}</Typography>
          <Typography variant='subtitle1' className='practicePageText'>{practiceMetaData[location.pathname].subText}</Typography>
          <br />
          {practiceMetaData[location.pathname].isPractice ?
            <PracticeSession  
              isSmallScreen={isSmallScreen} 
              isTinyMobileScreen={isTinyMobileScreen}
              selectedData={practiceMetaData[location.pathname].practiceData} 
              path={location.pathname} 
              has3rdPos={practiceMetaData[location.pathname].has3rdPos}
              isMix1stAnd3rdPos={practiceMetaData[location.pathname].isMix1stAnd3rdPos}
              keyName={practiceMetaData[location.pathname].practiceTitle.replace("Let's practice ", '')}
            />
            :
            <LearnSession 
              dataArray={practiceMetaData[location.pathname].learnData}
              dataIndex={dataIndex}
              setDataIndex={setDataIndex}
              isSmallScreen={isSmallScreen}
              isMediumScreen={isMediumScreen}
              pathname={location.pathname}
              keyName={''}
            />
          }
        </>
      }
    </>
  )
}

export default PracticePage;